import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { H1, Input, Loading } from "commons";
import { isSuccess, isFailure, IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { Message } from "../../components/Message";
import { MemoAsset } from "./MemoAsset";
import { redirect } from "../../components/DataOperations";
import { ERROR, getRefetchMessageAndAction } from "../../helpers/ErrorHelpers";
import { retryFetch } from "../../components/DataOperations";
import { setMemoAssets } from "../../reducers/memoAssetsActions";
import { requestObject } from "../../reducers/requestsActions";

export function MemoAssets({ requestStatus, memoAssets }) {
    const handleClose = () => {
        redirect("/home");
    };

    const getMemoAssetFields = memoAssets => {
        return (memoAssets || [])
            .filter(memoAsset => memoAsset.approximateValue)
            .map(memoAsset => <MemoAsset key={memoAsset.planNumber} asset={memoAsset} />);
    };

    const refetch = () => {
        retryFetch(requestStatus.href, setMemoAssets, "memoAssets");
    };

    const { message, action } = getRefetchMessageAndAction(requestStatus, refetch);

    return (
        <MemoAssetsMainDiv id="section-memo-assets">
            <H1>Memo Assets</H1>
            <Fragment>
                <Message
                    severity={ERROR}
                    text={message}
                    errorCode={requestStatus.errorCode}
                    shown={!!message}
                    padding="0px"
                    action={action}
                />
                {!isFailure(requestStatus.status) && (
                    <Loading
                        displayWhen={isSuccess(requestStatus.status)}
                        className="spinner-big"
                        size={35}
                    >
                        <MemoAssetsDiv>{getMemoAssetFields(memoAssets)}</MemoAssetsDiv>
                        <ButtonsDiv>
                            <BackButton
                                onClick={handleClose}
                                type="submit"
                                value="Back to home"
                                textAlign="center"
                            />
                        </ButtonsDiv>
                    </Loading>
                )}
            </Fragment>
        </MemoAssetsMainDiv>
    );
}

export const MemoAssetsMainDiv = styled.div`
    width: 100%;
`;

export const MemoAssetsDiv = styled.div`
    display: flex;
    flex-flow: row wrap;
    margin: 1%;
`;

export const ButtonsDiv = styled.div`
    display: flex;
`;

export const BackButton = styled(Input)`
    flex: 0 0;
`;

MemoAssets.defaultProps = {
    memoAssets: [],
    requestStatus: {
        status: IN_PROGRESS
    }
};

MemoAssets.propTypes = {
    memoAssets: PropTypes.array,
    requestStatus: requestObject
};
